module.exports = __webpack_public_path__ + "22-o1.jpg?1659b561a8b86be5e8274aec43372ad6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/22-o1.jpg
// module id = 644
// module chunks = 0